// extracted by mini-css-extract-plugin
module.exports = {"container":"qs-z","productName":"rs-z","modal":"ss-z","dimensions":"ts-z","recipientEmail":"us-z","lowStock":"vs-z","recommendedFit":"ws-z","notRecommendedFit":"xs-z"};